export function createColorPanel(colors: string[][]): HTMLElement {
  const colorRows = colors.map((rowColors) => {
    const colorItems = rowColors.map((color) => {
      const item = document.createElement('div')
      item.classList.add('toolbar-color-item')
      item.dataset.value = color
      item.style.backgroundColor = color
      return item
    })
    const row = document.createElement('div')
    row.classList.add('toolbar-color-row')
    row.append(...colorItems)
    return row
  })
  const wrapper = document.createElement('div')
  wrapper.classList.add('wrapper')
  wrapper.append(...colorRows)
  return wrapper
}
